import React, { Component } from 'react';
import cn from 'classnames';
import styles from './About.scss';
import { useTranslation, withTranslation } from 'react-i18next';
import houseIcon from './house.svg';
import totalAreaIcon from './total.svg';
import ReactTooltip from 'react-tooltip';
import { createSelector } from 'reselect';

import Print from 'components/Building/Print';
import SpinnerImage from 'components/common/SpinnerImage';
import zoomIcon from 'assets/images/icons/icon-zoom.svg';
import iconLock from 'assets/images/icons/icon-lock.svg';

import { connect, useDispatch } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { ROOT_URL } from 'constants/Config';
import { formatNumber, printNumber } from 'utils';
import CollectionsDialog from '../../../Main/CollectionsDialog';
import { useLocation } from 'react-router';
import tracker from '../../../../../services/tracker';
import { isReserved as isReservedFunc } from '../../../../../helper';
import { ViewType } from '../ViewType';
import { gaEvent, trackGA } from 'services/ga';
import ShareLotButton from 'components/ShareLotButton';

const AddToCollection = ({ chessId, building, isTable, profile, objectType }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname.includes('print')) {
    return null;
  }

  const handleClick = () => {
    tracker.sendEvent('Web_Lots_AddToCollection', {
      name: building.title,
      id: building.id,
    });

    trackGA(
      gaEvent.buildingChessLotAboutButtonsClick({
        eventLabel: 'v_podborku',
        eventContext: isTable ? 'shahmatka' : 'spisok',
        productType: objectType,
        productName: building.title,
        productID: building.id,
        user_id: profile.id,
      })
    );

    dispatch(
      setPopUp(
        <CollectionsDialog
          chessId={chessId}
          building={{
            data: building,
          }}
          profile={profile}
          objectType={objectType}
        />,
        {
          closeStyleName: 'Default',
          contentStyleName: 'Default',
          closeIcon: 'default',
          lockScroll: false,
        }
      )
    );
  };

  return (
    <p className={styles.Button} onClick={handleClick}>
      {t('components.building.rightMenu.addToCollection')}
    </p>
  );
};

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };

    this.setPopUp = this.setPopUp.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  componentDidUpdate(prev) {
    if (prev.data !== this.props.data) {
      this.setState({ isLoaded: false });
    }
  }

  handleTrackEvent = ({ eventName, eventLabel }) => {
    const { profile, objectType, building, isTable } = this.props;
    const eventContext = isTable ? 'shahmatka' : 'spisok';

    trackGA(
      gaEvent[eventName]({
        eventLabel,
        eventContext,
        productType: objectType,
        productName: building.title,
        productID: building.id,
        user_id: profile.id,
      })
    );
  };

  setPopUp() {
    const { setPopUp, data: room, building, t, currency } = this.props;
    const {
      costFormatted = formatNumber(room.data.priceAll),
      priceFormatted = formatNumber(room.data.priceM),
    } = room.data;
    const isReserved = isReservedFunc(room.data.status);
    const isCottage = building.type_id === 2;

    this.handleTrackEvent({
      eventName: 'buildingChessLotAboutButtonsClick',
      eventLabel: 'uvelichit_planirovku_kvartiry',
    });

    setPopUp(
      <div className={styles.PopUpOuter}>
        <div className={styles.PopUpInner}>
          <div className={styles.TopInfo}>
            <span>
              {building.title} /{' '}
              {room.data.floorName == 'М'
                ? t('components.building.rightMenu.attic')
                : `${room.data.floorName} ${t('components.building.rightMenu.floor')}`}{' '}
              / {isCottage ? '' : '№'}
              {printNumber(room.data.number)}{' '}
            </span>
          </div>
          <div className={styles.BottomInfo}>
            <div className={styles.LeftInfo}>
              <SpinnerImage
                key={room.id}
                className={styles.ImageInfo}
                imageSrc={`${ROOT_URL}/image/polygon?id=${room.data.poligon_id}&preset=800`}
                imageAlt="Room"
                spinner={<div className={styles.LoaderInfo} />}
              />
            </div>
            <div className={styles.RightInfo}>
              {room.hidden ? (
                isReserved ? (
                  <div className={styles.SoldInfo}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t('components.building.rightMenu.reserved'),
                      }}
                    />
                  </div>
                ) : (
                  <div className={styles.SoldInfo}>
                    <span>{t('components.building.rightMenu.sold')}</span>
                  </div>
                )
              ) : isReserved && costFormatted == 0 ? (
                <div className={styles.SoldInfo}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('components.building.rightMenu.reserved'),
                    }}
                  />
                </div>
              ) : (
                <div>
                  <div className={styles.PopupFlatInfo}>
                    <span className={styles.FlatNum}>
                      {isCottage ? '' : '№'}
                      {printNumber(room.data.number)}
                    </span>
                    <div className={styles.PopupTagsWrap}>
                      {room.data.view_action === '1' && !(room.data.status === 'soldStatus') ? (
                        <span className={styles.TagPromo}>
                          {t('components.building.rightMenu.promo')}
                        </span>
                      ) : null}
                      {isReserved ? (
                        <span className={styles.TagReserve}>
                          <i>{t('components.building.rightMenu.reserve')}</i>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className={styles.PriceInfo}>
                    {t('components.building.rightMenu.cost', { costFormatted, currency })}
                    <div className={styles.SmallInfo}>
                      <span>
                        {t('components.building.rightMenu.price', { priceFormatted, currency })}
                      </span>
                    </div>
                  </div>

                  <div className={cn(styles.FlatOptions, styles.PopupFlatOptions)}>
                    {room.data.area ? (
                      <div className={styles.FlatOption}>
                        <span>
                          <img src={houseIcon} />{' '}
                          {t('components.building.rightMenu.area', { area: room.data.area })}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    {room.data.apartmentsName ? (
                      <div className={styles.FlatOption}>
                        {t(`components.building.chess.${room.data.apartmentsName}`)}
                      </div>
                    ) : (
                      ''
                    )}
                    {room.data.interior == 'predChistInt' ? (
                      <div className={styles.FlatOption}>
                        <span>{t('components.building.rightMenu.predChistInt')}</span>
                      </div>
                    ) : room.data.interiorName ? (
                      <div className={styles.FlatOption}>
                        <span>{t(`components.building.chess.${room.data.interiorName}`)}</span>
                      </div>
                    ) : (
                      ''
                    )}
                    {!!room.data.floors && (
                      <div className={styles.FlatOption}>
                        {t('components.building.rightMenu.floorNumber', {
                          number: room.data.floors,
                        })}
                      </div>
                    )}
                    {room.data.totalArea > 0 && isCottage && (
                      <div className={styles.TotalArea}>
                        <img src={totalAreaIcon} />{' '}
                        {t('components.building.rightMenu.totalArea', {
                          totalArea: room.data.totalArea,
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>,
      {
        className: styles.popupFlat,
        backgroundClassName: styles.popupFlatBg,
        contentClassName: styles.popupFlatContent,
        closeIcon: 'gallery',
        hideCloseIcon: true,
        onClose: () => this.handleTrackEvent({ eventName: 'buildingChessLotPlanCloseClick' }),
      }
    );
  }

  handleImageLoad() {
    this.setState({ isLoaded: true }, ReactTooltip.rebuild);
    if (this.props.handleImageLoad) {
      this.props.handleImageLoad();
    }
  }
  renderFund = () => {
    const {
      data: room,
      print,
      client,
      building: { type_id },
      t,
    } = this.props;

    return (
      <div className={cn(styles.About, { [styles.Client]: client }, { [styles.Print]: print })}>
        <div className={cn(styles.Row, styles.Wide)}>
          <div className={styles.Floor}>
            <span className={styles.FloorNumber}>{`${type_id === 2 ? '' : '№'}${printNumber(
              room.data.number
            )}`}</span>
          </div>
          <div className={styles.FlatReserved}>
            <img src={iconLock} alt="" className={styles.FlatReservedImage} />
            <p
              className={styles.FlatReservedText}
              dangerouslySetInnerHTML={{
                __html:
                  type_id === 1
                    ? t('components.building.rightMenu.flatReserved')
                    : t('components.building.rightMenu.houseReserved'),
              }}
            />
          </div>
        </div>
      </div>
    );
  };
  renderReserved = () => {
    const {
      data: room,
      sectionId,
      print,
      client,
      withImage = true,
      chessfilter,
      isClientView,
      building: { type_id },
      t,
      currency,
    } = this.props;
    const {
      costFormatted = formatNumber(room.data.priceAll),
      priceFormatted = formatNumber(room.data.priceM),
    } = room.data;
    const { isLoaded } = this.state;
    const isReserved = isReservedFunc(room.data.status);
    const isAssign = room.data.status == 'assignmentStatus';

    return (
      <div
        className={cn(
          styles.About,
          { [styles.Client]: client },
          { [styles.Print]: print },
          { [styles.Chessfilter]: chessfilter }
        )}
      >
        {withImage && room.data.poligon_id ? (
          <div className={cn(styles.Row, styles.ImageWrap)}>
            <SpinnerImage
              key={room.id}
              className={styles.ImageInner}
              imageSrc={`${ROOT_URL}/image/polygon?id=${room.data.poligon_id}&preset=${
                print ? 1000 : 200
              }`}
              imageAlt="Room preview"
              handleImageLoad={this.handleImageLoad}
              handleImageError={this.props.handleImageError}
              spinner={<div className={styles.Loader} />}
            />
            {isLoaded ? (
              <div className={cn(styles.Zoom, 'tooltip')} onClick={this.setPopUp}>
                <img
                  alt="zoom"
                  src={zoomIcon}
                  data-tip={t('components.building.rightMenu.zoomImg')}
                  data-for="global"
                />
              </div>
            ) : null}
          </div>
        ) : null}

        {costFormatted !== '0' && room.data.area ? (
          <div
            className={cn(styles.Row, styles.RowReserved, { [styles.Wide]: !room.data.poligon_id })}
          >
            <div className={styles.Floor}>
              <span className={styles.FloorNumber}>{`${type_id === 2 ? '' : '№'}${printNumber(
                room.data.number
              )}`}</span>
              {room.data.view_action === '1' ? (
                <span className={styles.TagPromo}>{t('components.building.rightMenu.promo')}</span>
              ) : null}
              {isReserved ? (
                <span className={styles.TagReserve}>
                  <i>{t('components.building.rightMenu.reserve')}</i>
                </span>
              ) : null}
              {isAssign ? (
                <span className={styles.TagAssign}>
                  {t('components.building.rightMenu.assign')}
                </span>
              ) : null}
              {room.data.poligon_id && !isClientView ? (
                <Print
                  className={styles.PrintButton}
                  pure
                  tooltip={t('components.building.rightMenu.print')}
                  href={`/print1/${this.props.building.id}?roomPlan=${room.id}&sectionId=${sectionId}`}
                />
              ) : null}
            </div>
            {room.hidden ? (
              <div className={styles.Sold}>
                <span>{t('components.building.rightMenu.sold')}</span>
              </div>
            ) : (
              <div>
                <div className={styles.Price}>
                  {costFormatted !== '0' ? (
                    <span>
                      {t('components.building.rightMenu.cost', { costFormatted, currency })}
                    </span>
                  ) : (
                    ''
                  )}

                  {priceFormatted !== '0' ? (
                    <div className={styles.Small}>
                      <span>
                        {t('components.building.rightMenu.price', { priceFormatted, currency })}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>

                <div className={styles.FlatOptions}>
                  {room.data.area ? (
                    <div className={styles.FlatOption}>
                      <span>
                        <img src={houseIcon} />{' '}
                        {t('components.building.rightMenu.area', { area: room.data.area })}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {room.data.apartmentsName ? (
                    <div className={styles.FlatOption}>
                      {t(`components.building.chess.${room.data.apartmentsName}`)}
                    </div>
                  ) : (
                    ''
                  )}
                  {room.data.interior === 'predChistInt' ? (
                    <div className={styles.FlatOption}>
                      <span>{t('components.building.rightMenu.predChistInt')}</span>
                    </div>
                  ) : room.data.interiorName ? (
                    <div className={styles.FlatOption}>
                      <span>{t(`components.building.chess.${room.data.interiorName}`)}</span>
                    </div>
                  ) : (
                    ''
                  )}
                  {!!room.data.floors && (
                    <div className={styles.FlatOption}>
                      {t('components.building.rightMenu.floorNumber', { number: room.data.floors })}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={cn(styles.Row, styles.Wide)}>
            <div className={styles.Floor}>
              {`${type_id === 2 ? '' : '№'}${printNumber(room.data.number)}`}
            </div>
            <div className={styles.FlatReserved}>
              <p className={styles.FlatReservedText}>
                {t('components.building.rightMenu.reserved')}
              </p>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderSimple = () => {
    const {
      data: room,
      sectionId,
      print,
      client,
      withImage = true,
      chessfilter,
      isClientView,
      building: { type_id },
      t,
      currency,
      objectType,
      profile,
      isTable,
    } = this.props;
    const {
      costFormatted = formatNumber(room.data.priceAll),
      priceFormatted = formatNumber(room.data.priceM),
    } = room.data;

    const { isLoaded } = this.state;
    const isReserved = isReservedFunc(room.data.status);
    const isAssign = room.data.status == 'assignmentStatus';
    const isCottage = type_id === 2;

    return (
      <div
        className={cn(
          styles.About,
          { [styles.Client]: client },
          { [styles.Print]: print },
          { [styles.Chessfilter]: chessfilter }
        )}
      >
        {withImage && room.data.poligon_id ? (
          <div className={cn(styles.Row, styles.ImageWrap)}>
            <SpinnerImage
              key={room.id}
              className={styles.ImageInner}
              imageSrc={`${ROOT_URL}/image/polygon?id=${room.data.poligon_id}&preset=${
                print ? 1000 : 200
              }`}
              imageAlt="Room preview"
              handleImageLoad={this.handleImageLoad}
              handleImageError={this.props.handleImageError}
              spinner={<div className={styles.Loader} />}
            />
            {isLoaded ? (
              <div className={styles.Zoom} onClick={this.setPopUp}>
                <img
                  alt="zoom"
                  src={zoomIcon}
                  data-tip={t('components.building.rightMenu.zoomImg')}
                  data-for="global"
                />
              </div>
            ) : null}
          </div>
        ) : null}
        <div className={cn(styles.Row, styles.FlatInfo, { [styles.Wide]: !room.data.poligon_id })}>
          <div className={styles.Floor}>
            <span className={styles.FloorNumber}>{`${isCottage ? '' : '№'}${printNumber(
              room.data.number
            )}`}</span>
            {room.data.view_action === '1' && !(room.data.status === 'soldStatus') ? (
              <span className={styles.TagPromo}>{t('components.building.rightMenu.promo')}</span>
            ) : null}
            {isReserved ? (
              <span className={styles.TagReserve}>
                <i>{t('components.building.rightMenu.reserve')}</i>
              </span>
            ) : null}
            {isAssign ? (
              <span className={styles.TagAssign}>{t('components.building.rightMenu.assign')}</span>
            ) : null}

            {room.data.poligon_id && !isClientView ? (
              <Print
                className={styles.PrintButton}
                pure
                tooltip={t('components.building.rightMenu.print')}
                href={`/print/${this.props.building.id}?roomPlan=${room.id}&sectionId=${sectionId}`}
                onPrintClick={() =>
                  this.handleTrackEvent({
                    eventName: 'buildingChessLotAboutButtonsClick',
                    eventLabel: 'pechat',
                  })
                }
              />
            ) : null}
          </div>
          {room.hidden ? (
            <div className={styles.Sold}>
              <span>{t('components.building.rightMenu.sold')}</span>
            </div>
          ) : (
            <div>
              <div className={styles.Price}>
                {costFormatted !== '0' ? (
                  <span>
                    {t('components.building.rightMenu.cost', { costFormatted, currency })}
                  </span>
                ) : (
                  ''
                )}

                {priceFormatted !== '0' ? (
                  <div className={styles.Small}>
                    <span>
                      {t('components.building.rightMenu.price', { priceFormatted, currency })}
                    </span>
                  </div>
                ) : (
                  ''
                )}
              </div>

              <div className={styles.FlatOptions}>
                {room.data.area ? (
                  <div className={styles.FlatOption}>
                    <span>
                      <img src={houseIcon} />{' '}
                      {t('components.building.rightMenu.area', { area: room.data.area })}
                    </span>
                  </div>
                ) : (
                  ''
                )}
                {room.data.apartmentsName ? (
                  <div className={styles.FlatOption}>
                    {t(`components.building.chess.${room.data.apartmentsName}`)}
                  </div>
                ) : (
                  ''
                )}
                {room.data.interior === 'predChistInt' ? (
                  <div className={styles.FlatOption}>
                    <span>{t('components.building.rightMenu.predChistInt')}</span>
                  </div>
                ) : room.data.interiorName ? (
                  <div className={styles.FlatOption}>
                    <span> {t(`components.building.chess.${room.data.interiorName}`)}</span>
                  </div>
                ) : (
                  ''
                )}
                {!!room.data.floors && (
                  <div className={styles.FlatOption}>
                    {t('components.building.rightMenu.floorNumber', { number: room.data.floors })}
                  </div>
                )}
                {room.data.totalArea > 0 && isCottage && (
                  <div className={styles.TotalArea}>
                    <img src={totalAreaIcon} />{' '}
                    {t('components.building.rightMenu.totalArea', {
                      totalArea: room.data.totalArea,
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
          {ViewType(room.data)}
          {room.data.status !== 'soldStatus' && (
            <AddToCollection
              chessId={+this.props.data.id}
              building={this.props.building}
              profile={profile}
              objectType={objectType}
              isTable={isTable}
            />
          )}
          <ShareLotButton
            building={this.props.building}
            profile={profile}
            objectType={objectType}
            lotId={room.id}
          />
        </div>
      </div>
    );
  };

  render() {
    const { data: room } = this.props;

    const isFund = room.data.status === 'fundStatus';
    const isReserved = isReservedFunc(room.data.status);

    if (isFund) {
      return this.renderFund();
    }

    if (isReserved) {
      this.renderReserved();
    }

    return this.renderSimple();
  }
}

const aboutSelector = createSelector(
  (state) => state.profile,
  (profile) => ({
    currency: profile.user_region.country_currency_symbol,
  })
);

export default withTranslation()(connect(aboutSelector, { setPopUp })(About));



// WEBPACK FOOTER //
// ./src/components/Building/Chess/RightMenu/About/About.js